// extracted by mini-css-extract-plugin
export default {"root":"AdTypeSelector_root__s0cj6"};